import type { GeneralConfig } from '@shared/types/Config';

export const inventoryTypeConfig: GeneralConfig = {
    sortFieldMap: {},
};
